<!-- list-item-prefix -->
@if (hasPrefix$ | async) {
  <div class="modus-list-item-prefix">
    <ng-content select="[modus-prefix] md-icon"></ng-content>
    <ng-content select="[modus-prefix] modus-switch"></ng-content>
    <ng-content select="[modus-prefix] modus-checkbox"></ng-content>
  </div>
}

<!-- list-item-content -->
<div class="modus-list-item-content"><ng-content></ng-content></div>

<!-- list-item-suffix -->
@if (hasSuffix$ | async) {
  <div class="modus-list-item-suffix">
    <ng-content select="[modus-suffix] md-icon"></ng-content>
    <ng-content select="[modus-suffix] modus-switch"></ng-content>
    <ng-content select="[modus-suffix] modus-checkbox"></ng-content>
  </div>
}

<!-- <md-icon *ngIf="selected">check</md-icon> -->
